// Capitalize text
//
// Given a text of 'foo bar'
//
// <p>{{ text | capitalize }}</p>
//  -> <p>Foo bar</p>
//
// <p>{{ text | capitalize:'first' }}</p>
//  -> <p>Foo bar</p>
//
// <p>{{ text | capitalize:'all' }}</p>
//  -> <p>Foo Bar</p>
//
//
// Given a text of 'foo_bar'
//
// <p>{{ text | capitalize:'all':'_' }}</p>
//  -> <p>Foo_Bar</p>

module.exports = [() => (text, format, separator) => {
  if (!text) {
    return text;
  }

  format = format || 'first';

  if (format === 'all') {
    separator = separator || ' ';

      // Capitalize the first letter of each word of a sentence
    return text.split(separator).map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(separator);
  }
      // Capitalize the first letter of a sentence
  return text.charAt(0).toUpperCase() + text.slice(1);
}];



// WEBPACK FOOTER //
// ./main/filters/capitalize-filter.js